import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { map } from 'rxjs';

import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { PieChartComponent } from 'src/app/shared/component/charts/pie-chart/pie-chart.component';
import { GenericChartCardComponent } from 'src/app/shared/component/generic-card/generic-chart-card/generic-chart-card.component';
import { AppConsumptionModel } from 'src/app/core/data/model/app-consumption.model';
import { BaseChart } from 'src/app/core/data/model';
import { DashboardRepository } from 'src/app/core/data/repository';
import { ColorsConstants } from 'src/app/shared/common';
import { ChartCardCallerCallBack } from 'src/app/shared/bloc/chart-card-bloc';
import { ChartHeaderData } from 'src/app/shared/interfaces';
import { ChartCardHeaderDataComponent } from 'src/app/shared/component/generic-card/chart-card-header-data/chart-card-header-data.component';
import { FilterFormGroup } from 'src/app/shared/component/base-filter-component/base-filter-component';

@Component({
  selector: 'app-app-consumption-chart',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    GenericChartCardComponent,
    PieChartComponent,
    ChartCardHeaderDataComponent,
  ],
  templateUrl: './app-consumption-chart.component.html',
  styleUrls: ['./app-consumption-chart.component.scss'],
})
export class AppConsumptionChartComponent extends BaseComponent implements OnInit {
  form!: FilterFormGroup;
  headerData: ChartHeaderData[];
  caller: ChartCardCallerCallBack<BaseChart>;

  constructor(injector: Injector, private dashboardRepository: DashboardRepository) {
    super(['DASHBOARD'], injector, true);
  }

  ngOnInit(): void {
    this.initializeForm();
    this.callCaller();
  }

  private initializeForm(): void {
    this.form = new FilterFormGroup({});
  }

  private callCaller(): void {
    this.caller = () => {
      return this.dashboardRepository.getAppConsumption().pipe(
        map((res) => {
          return this.constructChart(res);
        })
      );
    };
    this.injector.get(ChangeDetectorRef).detectChanges();
  }

  private constructChart(res: AppConsumptionModel): BaseChart[] {
    console.log(res);
    const remaining = res.total - res.consumption;

    const chart = new BaseChart([res.consumption, remaining], null, [
      this.currentThemeColors.PRIMARY_COLOR,
      this.currentThemeColors.GREY_COLOR_400,
    ]);

    this.initializeChartHeader([chart], res);
    return [chart];
  }

  private initializeChartHeader(chartData: BaseChart[], consumption: AppConsumptionModel): void {
    const chart: BaseChart = chartData[0];
    this.headerData = [
      {
        label: this.translationsList['DASHBOARD']['CHARTS']['TOTAL'],
        count: consumption.total,
      },
      {
        label: this.translationsList['DASHBOARD']['CHARTS']['CONSUMED'],
        count: consumption.consumption,
      },
      {
        label: this.translationsList['DASHBOARD']['CHARTS']['REMAINING'],
        count: consumption.total - consumption.consumption,
      },
    ];
  }
}
